/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { ReviewMediaItem, ReviewType } from '../interface/types';

export const extractMediaItems = (
  photos: ReviewType['reviewPhotos'],
  videos: ReviewType['reviewVideos'],
): ReviewMediaItem[] => {
  const photoItems: ReviewMediaItem[] = (photos || [])
    .map((photo) => {
      const normalSize = photo.photoSizes?.find((size) => size.photoSizeId === 'normal');
      const url = normalSize?.photoUrl ?? '';

      return {
        type: 'photo' as const,
        url,
        caption: photo.photoCaption,
      };
    })
    .filter((photo) => photo.url);

  const videoItems: ReviewMediaItem[] = (videos || [])
    .map((video) => {
      const thumbnailUrl = video.videoThumbnailUrl;
      const videoUrl = video.videoUrl;

      return {
        type: 'video' as const,
        thumbnailUrl,
        videoUrl,
        caption: video.caption,
        videoCaptionUrl: video.videoCaptionUrl,
      };
    })
    .filter((video) => video.videoUrl && video.thumbnailUrl);

  return [...photoItems, ...videoItems];
};
